import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const EfisModalAtribuirProcesso = ({
  title,
  body,
  children,
  primaryLabel,
  secondaryLabel,
  show,
  loadingConfirmationAction,
  closeHandler,
  confirmationHandler,
}) => (
  <Modal show={show} onHide={() => closeHandler()} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>{title || "Tem certeza disso?"}</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      {typeof body === "string" ? <p style={{ marginBottom: 0 }}>{body}</p> : body}
      {children}
    </Modal.Body>

    <Modal.Footer>
      {loadingConfirmationAction ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Button
          variant="primary"
          onClick={() => {
            confirmationHandler();
          }}
        >
          {primaryLabel || "Confirmar"}
        </Button>
      )}
      <Button variant="light" onClick={() => closeHandler()}>
        {secondaryLabel || "Cancelar"}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default EfisModalAtribuirProcesso;
